// Auto-import CSS when the component is used
import './index.css';

// This ensures CSS is loaded automatically
export const loadStyles = () => {
  // CSS is already imported above, this is just for explicit loading if needed
  return true;
};
